<template>
    <div>
        <loader v-if="isLoading" />
        <b-table-simple
            v-else
            borderless
            hover
            class="list"
            id="table-attachments"
        >
            <b-thead>
                <b-tr>
                    <b-th>Title:</b-th>
                    <b-th>Summary:</b-th>
                    <b-th>Source:</b-th>
                    <b-th v-if="!isSoap">Reference:</b-th>
                    <!-- Rollback to original layout -->
                    <!-- <b-th>Added By:</b-th> -->
                    <!-- <b-th>Added:</b-th> -->
                    <b-th>Attached:</b-th>
                    <b-th></b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="(doc, i) in documents" :key="i">
                    <b-td>
                        <input type="hidden" name="id" :value="doc.id" />

                        <a :href="`${doc.file_uri}`" target="_blank">
                            {{ doc.title || "-" }}
                        </a>
                    </b-td>

                    <b-td>
                        <div v-if="doc.summary">
                            <b>Notes: </b>{{ doc.summary }}
                        </div>
                    </b-td>

                    <b-td v-if="doc.business_id === bussinessId">
                        <span
                            v-if="
                                !_.isEmpty(doc.source_details) &&
                                !_.isEmpty(doc.source_name)
                            "
                        >
                            <contact-name
                                v-if="doc.source_type == 3"
                                :contact="doc.source_details"
                                type="business"
                            ></contact-name>
                            <contact-name
                                v-else-if="doc.source_type == 2"
                                :contact="doc.source_details"
                                type="actor"
                            ></contact-name>
                            <client-name
                                v-else
                                :client="doc.source_details"
                                :text="doc.source_details.full_name"
                            />
                        </span>
                        <span v-else-if="doc.source_type == 6">
                            LifeLearn ClientEd
                        </span>
                    </b-td>
                    <b-td v-else>
                        <span
                            v-if="
                                !_.isEmpty(doc.source_details) &&
                                !_.isEmpty(doc.source_name)
                            "
                            v-html="doc.source_details.full_name"
                        ></span>
                    </b-td>

                    <b-td v-if="!isSoap">
                        <div v-if="doc.reference_name">
                            <strong
                                v-if="
                                    doc.record &&
                                    doc.record.item &&
                                    doc.record.item.type != LAB_TYPE
                                "
                                class="text-primary cursor-pointer"
                                @click="editRecord(doc)"
                            >
                                {{ doc.reference_name }}
                            </strong>
                            <a
                                v-else-if="doc.record && doc.reference_url"
                                :href="CI_APPS + doc.reference_url"
                            >
                                {{ doc.reference_name }}
                            </a>
                            <a
                                v-else-if="
                                    doc.reference_name && doc.reference_url
                                "
                                :href="CI_APPS + doc.reference_url"
                            >
                                {{ doc.reference_name }}
                            </a>

                            <span v-else-if="doc.reference_name">
                                {{ doc.reference_name }}</span
                            >
                        </div>
                        <a
                            :href="CI_APPS + doc.soap.ci_url"
                            v-else-if="
                                doc.soap && doc.soap.id && doc.soap.ci_url
                            "
                        >
                            {{ doc.soap.label }}
                        </a>
                        <span v-else-if="doc.soap && doc.soap.id">
                            {{ doc.soap.label }}
                        </span>
                    </b-td>

                    <!-- Rollback to original layout -->
                    <!-- <b-td>
                        {{ doc.create_by ? doc.create_by.label : "-" }}
                    </b-td> -->

                    <b-td>
                        {{ _carbonDateDisplay(doc.create_at) }}
                    </b-td>

                    <b-td
                        class="options"
                        v-if="isLoadingPrintRecordId !== doc.id"
                    >
                        <b-dropdown
                            size="sm"
                            variant="link"
                            right
                            no-caret
                            v-if="showOptions(doc)"
                        >
                            <template v-slot:button-content>
                                <i class="cus-cog-down"></i>
                            </template>
                            <b-dropdown-item
                                v-if="
                                    _hasAccess('patient.attachment.update') &&
                                    isDocImage(doc.filename) &&
                                    !isLabProfile
                                "
                                @click="annotate(doc)"
                            >
                                <i class="cus-picture-edit"></i>
                                Annotate Image
                            </b-dropdown-item>
                            <b-dropdown-item
                                v-if="_hasAccess('patient.attachment.update')"
                                @click="editAttachment(doc)"
                            >
                                <i class="cus-page-white-edit"></i>
                                Edit Attachment
                            </b-dropdown-item>
                            <b-dropdown-item
                                @click="emailAttachment(doc)"
                                v-if="
                                    _hasAccess('patient.attachment.update') &&
                                    !isLabProfile
                                "
                            >
                                <i class="cus-email"></i> Email Attachment
                            </b-dropdown-item>
                            <b-dropdown-item
                                v-if="_hasAccess('patient.attachment.delete')"
                                @click="promptDelete('attachment', doc.id)"
                            >
                                <i class="cus-delete"></i> Delete Attachment
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-td>
                    <b-td class="options" v-else>
                        <moon-loader color="black" size="16px" />
                    </b-td>
                </b-tr>
                <b-tr v-if="documents.length === 0">
                    <b-td colspan="6">
                        <i>No records available</i>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>

        <b-pagination
            v-if="showPagination"
            class="vet-pagination"
            align="right"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            prev-text="Prev"
            next-text="Next"
            :hide-goto-end-buttons="true"
            @change="changePage"
        />

        <modal-delete-document
            ref="modalDeleteDocument"
            @onSuccess="afterDeleted"
        />

        <modal-email-letter ref="modalEmailLetter" />
        <modal-email-attachment ref="modalEmailAttachment" />
        <modal-record ref="modalRecord" @onSuccess="getDocuments" />
        <Annotate
            v-if="isShowImageEditor"
            @close="closeImageEditor"
            module="patient"
            :file="imageEditor.file"
            :filename="imageEditor.filename"
            :name="imageEditor.name"
            :imageUrl="imageEditor.image"
            :entityId="imageEditor.entityId"
        />
    </div>
</template>

<script>
import DOCUMENTS from "@/constants/documents";
import PatientDocument from "@/services/patient-documents";
import Records from "@/services/records";

import Loader from "@/components/elements/loader-list";
import MoonLoader from "vue-spinner/src/MoonLoader.vue";
import ClientName from "@/components/commons/client-name";
import ContactName from "@/components/commons/contact-name";

import ModalDeleteDocument from "@/components/client-documents/document-delete-attachment-modal";
import ModalEmailLetter from "@/components/client-documents/document-email-letter-modal";
import ModalRecord from "@/module/commons/record/create-update";
import Annotate from "@/components/commons/annotate";
import ModalEmailAttachment from "@/components/documents/document-email-attachment-modal.vue";

export default {
    components: {
        Loader,
        ModalEmailAttachment,
        ModalDeleteDocument,
        ModalEmailLetter,
        MoonLoader,
        ContactName,
        ClientName,
        ModalRecord,
        Annotate
    },
    props: {
        patientDetails: {
            type: Object
        },
        labId: {
            type: String
        },
        soapId: {
            type: String
        }
    },
    data() {
        return {
            documents: [],
            isLoading: false,
            clientId: this.$store.state.client.client_id,
            isLoadingPrintRecordId: false,
            currentPage: 1,
            totalRows: 0,
            perPage: 20,
            showPagination: false,
            CI_APPS: process.env.CI_APPS,
            LAB_TYPE: 7,
            isShowImageEditor: false,
            imageEditor: {
                file: "",
                name: "",
                image: "",
                entityId: null
            }
        };
    },
    computed: {
        userId() {
            return this.$route.params.id;
        },
        patientId() {
            return this.patientDetails ? this.patientDetails.id : null;
        },
        bussinessId() {
            return this._setting.business_id;
        },
        isLabProfile() {
            return this.$route.name == "lab";
        },
        isSoap() {
            // by default this components is used in patient profile
            return this.$route.name === "soap";
        }
    },
    watch: {
        patientId() {
            if (this.labId && this.patientId != null) {
                this.getLabDocuments(1);
            }
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init(page = 1) {
            this.isLoading = true;
            if (!this.labId) this.getDocuments(page);
            if (this.labId && this.patientId != null)
                this.getLabDocuments(page);
        },
        closeImageEditor() {
            this.isShowImageEditor = false;
        },
        isDocImage(filename = "") {
            let ext = filename.split(".").pop().toLowerCase();
            return ["jpg", "jpeg", "png", "gif", "webp"].includes(ext);
        },
        annotate(doc) {
            this.imageEditor = {
                file: doc.title,
                name: `${doc.patient.name} (${doc.patient.index})`,
                image: doc.file_uri,
                entityId: doc.patient.id,
                filename: doc.filename
            };
            this.isShowImageEditor = true;
        },
        showOptions(doc) {
            return (
                (this._hasAccess("patient.attachment.update") ||
                    this._hasAccess("patient.attachment.delete")) &&
                this._setting.business?.id == doc.business_id
            );
        },
        editAttachment(attachment) {
            this.$store.commit("patient/openModalNewAttachment", {
                action: "edit",
                attachment: attachment,
                module: this.MODULE.PATIENT,
                patient_id: this.patientId
            });
        },
        async getLabDocuments(page) {
            this.isLoading = true;

            try {
                const res = await PatientDocument.getLabAttachment({
                    page: page,
                    perPage: this.perPage,
                    patientId: this.patientId,
                    labId: this.labId
                });

                if (res.code === 200) {
                    this.documents = res.resources;
                }

                this.isLoading = false;

                // pagination
                this.currentPage = res.meta.current_page;
                this.totalRows = res.meta.total;
                this.perPage = res.meta.per_page;
                this.showPagination = res.meta.last_page > 1;
            } catch (e) {
                console.log(e);
            }
        },
        async getDocuments(page) {
            try {
                this.isLoading = true;

                const patientId = this.patientId;
                const type = "attachments";

                const res = await PatientDocument.getDocuments(
                    patientId,
                    type,
                    {
                        page: page,
                        perPage: this.perPage,
                        where:
                            this.isSoap && this.soapId
                                ? `soapId,=,${this.soapId}`
                                : null
                    }
                );

                if (res.message && res.message.code === 200) {
                    this.documents = res.resource.data;
                }

                this.isLoading = false;

                // pagination
                this.currentPage = res.resource.current_page;
                this.totalRows = res.resource.total;
                this.perPage = res.resource.per_page;
                this.showPagination = res.resource.last_page > 1;
            } catch (e) {
                console.log(e);
            }
        },
        properDate(rawDate) {
            return this._toDateTime(rawDate).toFormat(this._getLuxonFormat());
        },
        promptDelete(type, documentId) {
            this.$refs.modalDeleteDocument.open({
                type: type,
                id: documentId
            });
        },
        afterDeleted() {
            if (this.isSoap) {
                this.$emit(
                    "onSuccess",
                    "tabDocuments",
                    DOCUMENTS.VIEWS.ATTACHMENTS,
                    false
                );
            } else {
                this.$emit("onSuccess");
            }
            this.init();
        },
        changePage(nextPage) {
            this.init(nextPage);
        },
        editRecord(attachment) {
            let date = this._fromDateCarbon(attachment.record.date).toSeconds();
            if (
                attachment.record.invoice_item &&
                attachment.record.invoice_item.date
            ) {
                if (
                    this._fromDateCarbon(attachment.record.invoice_item.date) <
                    this._fromDateCarbon(attachment.record.date)
                ) {
                    date = this._fromDateCarbon(
                        attachment.record.invoice_item.date
                    ).toSeconds();
                }
            }

            this.$store.dispatch("checkBillingLock", {
                date,
                onProceed: () => {
                    Records.editRecordDetails(attachment.record.id).then(
                        response => {
                            if (response) {
                                this.$refs.modalRecord.open({
                                    ...attachment.record,
                                    patient: attachment.patient,
                                    clientID: this.getPatientOwnerId(),
                                    action: "edit",
                                    module: this.MODULE.PATIENT,
                                    record_resources: response
                                });
                            }
                        }
                    );
                },
                onError: message => this._message(message, "danger")
            });
        },
        getPatientOwnerId() {
            const { active_owners } = this.patientDetails;
            if (active_owners[0]) {
                return active_owners[0].id;
            } else {
                return null;
            }
        },
        emailAttachment(record) {
            if (
                this.patientDetails.primary_owner &&
                this.patientDetails.primary_owner[0]
            ) {
                record.recipient = this.patientDetails.primary_owner[0];
            }

            this.$refs.modalEmailAttachment.open(record);
        }
    }
};
</script>

<style scoped>
td.options {
    width: 50px;
    text-align: right;
}
.vet-pagination {
    margin-top: 50px;
}
</style>
